<mat-dialog-content class="mat-typography">
  <p>{{data.message}} </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" (click)="onCloseClick()">
    Annuler
  </button>
  <button mat-raised-button color="primary" [mat-dialog-close]="data" cdkFocusInitial data-cy="button-confirm-dialog-delete">
    Supprimer
  </button>
</mat-dialog-actions>
